<template>
  <div class="in_out" :class="more ? 'more_in' : ''">
    <!-- 正常页面显示语音列表 -->
    <div v-if="!more" class="data-list">
      <ul :class="talkList.length < 4 ? 'all-talk' : ''">
        <li v-for="(item, index) in talkList" :key="index">
          <img class="bell_icon" src="@/icon/newBg/notice_icon.png" alt="" />
          <el-tooltip
            effect="dark"
            :content="item.fromUserName + ' ' + item.commType + item.createdTime"
            placement="top"
            :disabled="newsDisabled"
          >
            <span class="news_name news" @mouseenter="newsWhenMouseEnter(index)"
              >{{ item.fromUserName }} {{ item.commType }}{{ item.createdTime }}</span
            >
          </el-tooltip>
        </li>
      </ul>
      <ul>
        <li v-for="(item, index) in talkListRight" :key="index">
          <img class="bell_icon" src="@/icon/newBg/notice_icon.png" alt="" />
          <el-tooltip
            effect="dark"
            :content="item.fromUserName + ' ' + item.commType + item.createdTime"
            placement="top"
            :disabled="rightDisabled"
          >
            <span class="news_name right" @mouseenter="rightWhenMouseEnter(index)"
              >{{ item.fromUserName }} {{ item.commType }}{{ item.createdTime }}</span
            >
          </el-tooltip>
        </li>
      </ul>
      <div v-if="(newsData.length = 0)" class="empty">{{ $t('NoDeviceVoiceData') }}</div>
    </div>
    <!-- 查看更多时 语音列表 table显示 并显示分页查询 -->
    <div v-if="more" class="more_table common-blue-contain ">
      <div class="search">
        <!-- 查询条件 -->
        <el-form :inline="true">
          <el-form-item :label="$t('VoiceType')">
            <el-select v-model="commTypeList" clearable :placeholder="$t('VoiceType')" :popper-append-to-body="false">
              <el-option :label="$t('VoiceMessage')" value="voice"></el-option>
              <el-option :label="$t('radioVoiceBroadcast')" value="broadcast"></el-option>
              <el-option :label="$t('radioWordBroadcast')" value="broadcastWord"></el-option>
              <el-option :label="$t('voiceCall')" value="chat"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" class="serachBtn" size="small" @click="changeRecordFind">
              {{ $t('query') }}
            </el-button>
          </el-form-item>
        </el-form>
      </div>
      <el-table :data="newsData" style="width: 100%" @sort-change="sortChange">
        <el-table-column type="index" :label="$t('SerialNo')" width="100" align="center">
          <template slot-scope="scope">
            <span>{{ (accessParam.currentPage - 1) * accessParam.pageSize + scope.$index + 1 }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="fromUserName" :label="$t('userNameH')" sortable="fromUserName" :sort-orders="['ascending', 'descending']"> </el-table-column>
        <el-table-column prop="commType" :label="$t('eventH')" sortable="commType" :sort-orders="['ascending', 'descending']"> </el-table-column>
        <el-table-column prop="createdTime" :label="$t('time')" sortable="createdTime" :sort-orders="['ascending', 'descending']"> </el-table-column>
      </el-table>
      <el-pagination
        class="pagination"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="accessParam.currentPage"
        :page-size="accessParam.pageSize"
        layout="total, prev, pager, next"
        :total="accessParam.allPage"
      >
      </el-pagination>
    </div>
  </div>
</template>
<script>
import { recordFind } from '@/api/new-home/newHome'
import { SortFun } from '@/util/dataSort'
export default {
  props: {
    more: {
      type: Boolean,
    },
    // 当前查询租户信息
    currenNode: {
      type: Array / Object,
    },
  },
  data() {
    return {
      // 对讲数据
      newsData: [],
      // 分页查询参数
      accessParam: { currentPage: 1, pageSize: 12, allPage: 0 },
      // 语音显示列表
      talkList: [],
      // 语音显示列表
      talkListRight: [],
      // 查询语音类型
      commTypeList: '',
      // 控制语音消息第一列悬浮显示
      newsDisabled: true,
      // 控制语音消息第二列悬浮显示
      rightDisabled: true,
    }
  },
  methods: {
    // 控制语音消息第一列悬浮显示
    newsWhenMouseEnter(index) {
      const cellChild = document.querySelectorAll('.news')[index]
      if (cellChild.scrollWidth > cellChild.offsetWidth) {
        this.newsDisabled = false
      } else {
        this.newsDisabled = true
      }
    },
    // 控制语音消息第二列悬浮显示
    rightWhenMouseEnter(index) {
      const cellChild = document.querySelectorAll('.right')[index]
      if (cellChild.scrollWidth > cellChild.offsetWidth) {
        this.rightDisabled = false
      } else {
        this.rightDisabled = true
      }
    },
    // 修改类型查询
    changeRecordFind() {
      this.accessParam.currentPage = 1
      this.accessParam.pageSize = 12
      this.accessParam.allPage = 0
      this.getRecordFind()
    },
    // 页数查询
    handleSizeChange(val) {
      this.accessParam.pageSize = val
      this.getRecordFind()
    },
    // 切换页数查询
    handleCurrentChange(val) {
      this.accessParam.currentPage = val
      this.getRecordFind()
    },
    // 点击表头排序
    sortChange({ column, prop, order }) {
      this.accessParam.sortColName = !order ? null : column.sortable
      this.accessParam.useAsc = order === 'descending' ? 0 : 1
      if (prop === 'commType') {
        this.newsData = this.newsData.sort(SortFun(prop, order === 'descending'))
      } else {
        this.accessParam.currentPage = 1
        this.getRecordFind()
      }
    },
    // 对讲消息
    getRecordFind() {
      // commTypeList 请求语音数据类型
      let type = []
      if (this.commTypeList) {
        type.push(this.commTypeList)
      }
      let param = {
        startTime: this.currenNode.startTime,
        endTime: this.currenNode.endTime,
        pageNum: this.accessParam.currentPage,
        pageSize: this.accessParam.pageSize,
        commTypeList: type,
        sortColName: this.accessParam.sortColName,
        useAsc: this.accessParam.useAsc,
      }
      recordFind(param).then(res => {
        if (res.state === 0) {
          for (let item of res.data.pageData.list) {
            // 根据相应的类型拼接详细信息
            if (item.commType === 'chat') {
              item.commType = this.$t('InitiatedVoiceCall')
              item.content = item.fromUserName + this.$t('InitiatedVoiceCall') + item.createdTime
            }
            if (item.commType === 'voice') {
              item.commType = this.$t('issue') + item.toUserName + this.$t('OneCallVoice')
              item.content =
                item.fromUserName + this.$t('issue') + item.toUserName + this.$t('OneCallVoice') + item.createdTime
            }
            if (item.commType === 'broadcast') {
              item.commType = this.$t('broadcastVoiceWasSent')
              item.content = item.fromUserName + this.$t('broadcastVoiceWasSent') + item.createdTime
            }
            if (item.commType === 'broadcastWord') {
              item.commType = this.$t('broadcastWordWasSent')
              item.content = item.fromUserName + this.$t('broadcastWordWasSent') + item.createdTime
            }
          }
          this.newsData = res.data.pageData.list
          this.talkList = this.newsData
          this.talkListRight = []
          if (this.newsData.length > 4) {
            this.talkList = this.newsData.slice(0, 4)
          }
          if (this.newsData.length > 4) {
            this.talkListRight = this.newsData.slice(4, 8)
          }

          // 总的信息数
          this.accessParam.allPage = res.data.pageData.total
        }
      })
    },
  },
  watch: {
    currenNode: {
      handler(val) {
        // 根据查询租户的信息改变触发查询信息
        this.getRecordFind()
      },
      deep: true,
    },
    more: {
      immediate: true,
      handler(val) {
        if (val) {
          if (this.more) {
            this.getRecordFind()
          }
        }
      },
    },
  },
}
</script>
<style lang="stylus" rel="stylesheet/stylus" scoped>
@import '~@/style/mixin.styl'
.in_out
  width: 100%
  height: 100%
  margin: 0 auto
  .data-list
    overflow hidden
  ul
    width: 50%
    float: left
    li
      width: 100%
      line-height: 30px
      cursor default!important
      display: flex
      align-items: center
      .bell_icon
        width 16px
        height 16px
        margin-right 10px
      .news_name
        width 100%
        no-wrap()
        margin-right 10px
      .news_time
        margin-left 10px
  .all-talk
    width: 100%
  .empty
    font-size: 16px
    color: #0E8BFF
    text-align: center
    margin-top 20px
.more_in
  width: 100%
  height 100%
  display: flex
  flex-direction: column
  align-items: center
  .select_date
    background: none
    box-shadow none
  .more_table
    width 96%
    height 100%
    margin-top 20px
  ul
    margin-left 80px
    margin-bottom: 20px
  .pagination
    margin-top 10px
>>> .el-table
  height 85% !important
  min-height: 60% !important
  overflow: auto
.search
  >>>.el-input__inner
    height: 36px;/*no*/
    line-height: 36px;/*no*/
</style>
